/**
 * Which parcels the hub door is booking back in.
 *
 * In the URL so the old `/ops/hub/reschedule` bookmark can redirect to a screen
 * that opens on the right tab, and so a refresh mid-shift doesn't drop the
 * operator back on "new".
 *
 * `new` and `declined` share an endpoint — the server decides which move a
 * parcel gets from its status. `rescheduled` is a different endpoint on
 * purpose: it never changes status, only custody. `assign` is not booking in at
 * all: it hands parcels already on the shelf to a chosen rider.
 */
export const HUB_MODES = ['new', 'declined', 'rescheduled', 'assign'] as const;

export type HubMode = (typeof HUB_MODES)[number];

export interface HubSearch {
    mode?: HubMode;
}

export function validateHubSearch(search: Record<string, unknown>): HubSearch {
    const { mode } = search;

    // An unknown value is dropped, not an error: a mistyped link should open
    // the screen, not a blank page.
    return HUB_MODES.find((candidate) => candidate === mode) === undefined
        ? {}
        : { mode: mode as HubMode };
}
